import { request } from '@/common/utils/request'

// 获取拜访对象初始化数据
export function getVisitObjectInit (params) {
  return request.get({
    url: 'feidian.gas.visit.bdapp.contactsInit',
    params
  }).then(res => res.data).catch(() => {
    return false
  })
}

// 获取拜访对象初始化数据
export function saveVisitObject (params) {
  return request.post({
    url: 'feidian.gas.visit.bdapp.saveContacts',
    params
  }).then(res => res.data).catch(() => {
    return false
  })
}
